import type { PlaygroundToolType } from '../types'

// Re-export character registry helpers (backwards compatibility).
export { DEFAULT_CHARACTER, getCharacterAllowedTools, getCharacterConfig } from './character-registry'

// The image-workflow manifest is the canonical source for active Gemini image
// and enrichment models. Keep these exports stable for current consumers.
export {
  DEFAULT_GEMINI_ENRICHMENT_MODEL,
  DEFAULT_GEMINI_ENRICHMENT_SETTINGS,
  DEFAULT_GEMINI_IMAGE_MODEL,
  DEFAULT_GEMINI_IMAGE_SETTINGS,
  GEMINI_ACTIVE_PRICING,
  GEMINI_ENRICHMENT_MODEL_OPTIONS,
  GEMINI_ENRICHMENT_MODEL_VALUES,
  GEMINI_ENRICHMENT_MODELS,
  GEMINI_FIXED_IMAGE_TOOL_MODELS,
  GEMINI_IMAGE_ASPECT_RATIOS,
  GEMINI_IMAGE_CONFIG,
  GEMINI_IMAGE_MODEL,
  GEMINI_IMAGE_MODEL_OPTIONS,
  GEMINI_IMAGE_MODEL_VALUES,
  GEMINI_IMAGE_MODELS,
  GEMINI_IMAGE_SIZES,
  GEMINI_IMAGE_TEMPERATURE_MAX,
  GEMINI_IMAGE_TEMPERATURE_MIN,
  GEMINI_IMAGE_TEMPERATURE_STEP,
  GEMINI_MULTIMODAL_MODEL,
  GEMINI_THINKING_LEVELS,
  getGeminiEnrichmentModel,
  getGeminiImageModel,
  getSupportedGeminiImageSizes,
  isGeminiImageSizeSupported,
  supportsGeminiGoogleSearch,
  supportsGeminiThinkingLevel
} from './gemini-image-model-manifest'

export type {
  GeminiAspectRatio,
  GeminiEnrichmentModel,
  GeminiImageModel,
  GeminiImageSize,
  GeminiModelPricing,
  GeminiThinkingLevel
} from './gemini-image-model-manifest'

// S3 prefix for per-character reference images (dynamically listed at runtime).
export const REFERENCE_IMAGE_PREFIX = 'nanobanana-reference'
// Deploy-managed, read-only copies of packages/assets/reference-images/<principal>/.
// Used only when a principal character has no uploaded references in this stage.
export const PRINCIPAL_REFERENCE_IMAGE_PREFIX = 'principal-reference'
// Admin-uploaded scale references for principal and dynamic characters.
export const SCALE_REFERENCE_IMAGE_PREFIX = 'character-scale-reference'

// Generation type display labels.
export const TOOL_TYPE_LABELS: Record<PlaygroundToolType, string> = {
  'character-wan': 'WAN 2.2 (EC2/ComfyUI)',
  'character-nanobanana': 'Nano Banana (Gemini)',
  background: 'Background Generation',
  inpaint: 'Inpainting',
  outpaint: 'Outpaint',
  upscale: 'AI Upscale',
  enrichment: 'Prompt Enrichment',
  'remove-background': 'Remove Background',
  composition: 'Composition',
  freeflow: 'FreeFlow',
  'reference-builder': 'Reference Builder'
}
